export enum BillingChargeSubtype {
  ReturnCoverage = "return_coverage",
  PackageProtectionPlus = "package_protection_plus",
  PackageProtection = "package_protection",
  FinalSaleReturnCoverage = "final_sale_return_coverage",
  ExtendedWarranty = "extended_warranty",
  UpsellRevenue = "upsell_revenue",
  UpsellRevenueRefunded = "upsell_revenue_refunded",
  ManagedClaimCredit = "managed_claim_credit",
  RedoManagedReturnsCoverage = "redo_managed_returns_coverage",
  InstantExchangeRecovery = "instant_exchange_recovery",
  InstantRefund = "instant_refund",
  RepairFeeCredit = "repair_fee_credit",
  CoverageRefundForCancelledOrder = "coverage_refund_for_cancelled_order",
  CancelledOrderPackageProtectionPlusRefund = "cancelled_order_package_protection_plus_refund",
  DeniedClaimPackageProtectionPlusRefund = "denied_claim_package_protection_plus_refund",
  CancelledOrderFinalSaleReturnCoverageRefund = "cancelled_order_final_sale_return_coverage_refund",
  CancelledOrderExtendedWarrantyRefund = "cancelled_order_extended_warranty_refund",
  CancelledOrderRmrProcessingCoverageShareRefund = "cancelled_order_rmr_processing_coverage_share_refund",
  CancelledOrderRmrConsolidationCoverageShareRefund = "cancelled_order_rmr_consolidation_coverage_share_refund",
  CancelledOrderInstantExchangeRecovery = "cancelled_order_instant_exchange_recovery",
  FinalSaleCredit = "final_sale_credit",
  CarrierClaimRefund = "carrier_claim_refund",
  ClaimPayout = "claim_payout",
  ClaimCommission = "claim_commission",
  ExchangeShippingCredit = "exchange_shipping_credit",
  PerOrder = "per_order",
  PerSms = "per_sms",
  PerEmail = "per_email",
  OrderTracking = "order_tracking",
  MerchantCoveredLabel = "merchant_covered_label",
  Damaged = "damaged",
  WrongProduct = "wrong_product",
  MerchantCarrierLabelCredit = "merchant_carrier_label_credit",
  ShippingCostShare = "shipping_cost_share",
  ReturnLabelMarkupRevenue = "return_label_markup_revenue",
  CustomerPaidLabel = "customer_paid_label",
  CarrierUpgrade = "carrier_upgrade",
  PerReturnFee = "per_return_fee",
  ReturnsProcessingFee = "returns_processing_fee",
  ExternalReturnsProcessingFee = "external_returns_processing_fee",
  ReturnFraudPrevention = "return_fraud_prevention",
  PointOfSale = "point_of_sale",
  PerRecycleRequestFee = "per_recycle_request_fee",
  ReFulfillmentRevenueShare = "re_fulfillment_revenue_share",
  ReFulfillmentShippingAdjustment = "re_fulfillment_shipping_adjustment",
  PerExchangePayoutFee = "per_exchange_payout_fee",
  MerchantCreatedReturnLabel = "merchant_created_return_label",
  PackagePickup = "package_pickup",
  CarrierPickup = "carrier_pickup",
  CanceledReturnLabelRefund = "canceled_return_label_refund",
  CanceledPickupRefund = "canceled_pickup_refund",
  OutboundLabel = "outbound_label",
  ReturnLabelAdjustment = "return_label_adjustment",
  ImplementationFee = "implementation_fee",
  CardProcessingFee = "card_processing_fee",
  ManualAdjustment = "manual_adjustment",
  ManualRefund = "manual_refund",
  VoidLabel = "void_label",
  VoidUsedLabel = "void_used_label",
  ChargeLabel = "charge_label",
  Refund = "refund",
  Miscellaneous = "miscellaneous",
  Surcharge = "surcharge",
  ReturnLabel = "return_label",
  MerchantCarrierFee = "merchant_carrier_fee",
  SubscriptionFee = "subscription_fee",
  RedeemPoints = "redeem_points",
  Insurance = "insurance",
  VoidInsurance = "void_insurance",
  TransactionFailureClawback = "transaction_failure_clawback",
  WmsFee = "wms_fee",
  RedoSupply = "redo_supply",
  LandedCostDuties = "landed_cost_duties",
  LandedCostTaxes = "landed_cost_taxes",
  LandedCostFees = "landed_cost_fees",
  VoidLandedCostDuties = "void_landed_cost_duties",
  VoidLandedCostTaxes = "void_landed_cost_taxes",
  VoidLandedCostFees = "void_landed_cost_fees",
  FreightPurchase = "freight_purchase",
  VoidFreightPurchase = "void_freight_purchase",
  ConsolidationShipping = "consolidation_shipping",
  RmrProcessingCoverageShare = "rmr_processing_coverage_share",
  RmrConsolidationCoverageShare = "rmr_consolidation_coverage_share",
  FinalSaleCreditAdjustment = "final_sale_credit_adjustment",
  FreeTrialCredit = "free_trial_credit",
  MerchantIncentive = "merchant_incentive",
  ZeroOutAccountBalance = "zero_out_account_balance",
  CancelledExtendedWarrantyRefund = "cancelled_extended_warranty_refund",
  CancelledPackageProtectionPlusRefund = "cancelled_package_protection_plus_refund",
  CancelledFinalSaleReturnCoverageRefund = "cancelled_final_sale_return_coverage_refund",
  CancelledInstantExchangeRecovery = "cancelled_instant_exchange_recovery",
  MerchantPaidPpPlusPerOrder = "merchant_paid_pp_plus_per_order",
  CoverageAdjustment = "coverage_adjustment",
  NonCoverageAdjustment = "non_coverage_adjustment",
  PpPlusAdjustment = "pp_plus_adjustment",
  FsrAdjustment = "fsr_adjustment",
  RmrAdjustment = "rmr_adjustment",
  OmsAdjustment = "oms_adjustment",
  OtherAdjustment = "other_adjustment",
  ClaimsAdjustment = "claims_adjustment",
  ChopAdjustment = "chop_adjustment",
  OrderTrackingAdjustment = "order_tracking_adjustment",
  ShopperAiAdjustment = "shopper_ai_adjustment",
  SubscriptionAdjustment = "subscription_adjustment",
  WarrantiesAdjustment = "warranties_adjustment",
  MarketingAdjustment = "marketing_adjustment",
  DutyDrawbackCredit = "duty_drawback_credit",
  ReduceBalance = "reduce_balance",
  PromotionalCredit = "promotional_credit",
  UspsPcPostageFee = "usps_pc_postage_fee",
  Writeoff = "writeoff",
  PersonalizedInsertFee = "personalized_insert_fee",
  PersonalizedInsertRevenueShare = "personalized_insert_revenue_share",
  RevShareCoverage = "rev_share_coverage",
  FinalSaleRevShareCoverage = "final_sale_rev_share_coverage",
  PpPlusRevShareCoverage = "pp_plus_rev_share_coverage",
  PackageProtectionRevShareCoverage = "package_protection_rev_share_coverage",
  CancelledPackageProtectionRefund = "cancelled_package_protection_refund",
  CancelledRevShareCoverageRefund = "cancelled_rev_share_coverage_refund",
  CancelledFinalSaleRevShareCoverageRefund = "cancelled_final_sale_rev_share_coverage_refund",
  CancelledPpPlusRevShareCoverageRefund = "cancelled_pp_plus_rev_share_coverage_refund",
  CancelledPackageProtectionRevShareCoverageRefund = "cancelled_package_protection_rev_share_coverage_refund",
  ReFulfillmentFixedFee = "re_fulfillment_fixed_fee",
  PurchaseOrderItem = "purchase_order_item",
  PurchaseOrderShipping = "purchase_order_shipping",
  SalesTax = "sales_tax",
  ExchangeOutboundLabelCredit = "exchange_outbound_label_credit",
}
